import React from "react";
//#region redux
import { AppState } from "store";
import { useSelector, useDispatch } from "react-redux";
//#endregion
//#region types
import { ReduxMessageProps } from "models/propTypes/messagePropTypes";
//#endregion
//#region constants
import { CommonConstants } from "utils/constants";
//#endregion
//#region components
import useFloatingMessages from "./useFloatingMessages";
import { ThunkDispatch } from "redux-thunk";
import { closeMessage } from "store/actions/utilActions";
import { AddSupportCaseLink } from "components/support";
//#endregion

const ReduxMessage: React.FC<ReduxMessageProps> = (props) => {
  const message = useSelector((store: AppState) => store.util.message);
  const dialogQueue = useSelector((store: AppState) => store.util.dialogQueue);
  const { enqueueMessage } = useFloatingMessages();
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  React.useEffect(() => {
    const isRevenueReportingDialogOpen = (dialogQueue ?? []).some(
      (dialog) => dialog.id === CommonConstants.RevenueReportingCreateDialogId
    );
    const isInTodoPage = window.location.href.includes("/Todo") && !isRevenueReportingDialogOpen;
    const isGlobalFloatingMessageProvider = props.isGlobal;
    const isGlobalMessage = message.isGlobal;

    if (isInTodoPage) {
      if (isGlobalFloatingMessageProvider && !isGlobalMessage) return;
      if (!isGlobalFloatingMessageProvider && isGlobalMessage) return;
    }

    if (message.messageText) {
      if (message.showSupportLink) {
        enqueueMessage(
          // One element, not a fragment: notistack lays the snackbar's content out as a flex row,
          // so two children become two flex items and the link lands beside the text instead of
          // reading as the end of the sentence.
          <span>
            {message.messageText} <AddSupportCaseLink />
          </span>,
          message.type,
          // Persists until closed: the customer cannot resolve this alone and has to read the text
          // and reach the link, which a five-second timer does not allow. Same as other messages
          // that ask for action, e.g. the salary deviation form errors and salary report warnings.
          false,
          undefined,
          // A new element never equals the previous one, so without a key derived from the text
          // repeated identical errors would stack instead of being deduplicated.
          { key: `support-link:${message.messageText}` }
        );
      } else {
        enqueueMessage(message.messageText, message.type, true);
      }
      dispatch(closeMessage());
    }
  }, [message.messageText]);

  return <></>;
};

export default ReduxMessage;
